// extracted by mini-css-extract-plugin
export default {"root":"PlasmicDeleteMilestone_root__JkClO","rootfirstOne":"PlasmicDeleteMilestone_rootfirstOne__B2bia"};